export default __webpack_public_path__ + "static/media/vinaiHover.cc41dd2d.svg";